/**
 * QA-521 — 옵션이 없는 상품의 기본 SKU 라벨. catalog 가 옵션 없이 저장한 상품에 이 라벨을 붙인다(CatalogProductWriter
 * DEFAULT_VARIANT_LABEL, CatalogQueryService 도 "기본"/빈 값을 '옵션 없음'으로 본다).
 */
export const DEFAULT_OPTION_LABEL = '기본';

/** 화면에 보일 옵션 라벨 — 빈 값·기본 SKU 라벨("기본")은 null(옵션 없는 상품이라 표기하지 않는다). */
export const visibleOptionLabel = (label: string | null | undefined): string | null => {
  const v = label?.trim();
  return v && v !== DEFAULT_OPTION_LABEL ? v : null;
};
